import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NodeActionsComponent } from './node-actions.component';
import { MaterialModule } from 'src/app/material.module';
import { IconModule } from 'src/app/shared/components/icon/icon.module';
import { ButtonsModule } from 'src/app/shared/components/buttons/buttons.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

@NgModule({
  declarations: [NodeActionsComponent],
  imports: [
    CommonModule,
    DirectivesModule,
    MaterialModule,
    ButtonsModule,
    IconModule,
    NgxGoogleAnalyticsModule,
  ],
  exports: [NodeActionsComponent],
})
export class NodeActionsModule {}
